var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFornecedores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.018,
    height: 22.526,
    viewBox: "0 0 22.018 22.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fornecedores",
    transform: "translate(-1.638 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_989",
    "data-name": "Grupo 989",
    transform: "translate(1.638 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_979",
    "data-name": "Grupo 979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1482",
    "data-name": "Caminho 1482",
    d: "M9.69,18.657a.4.4,0,0,1-.363-.254L5,3.87l-2.4.727a.41.41,0,0,1-.291-.036c-.109-.073-.182-.145-.182-.254L1.661,2.78a.344.344,0,0,1,.254-.472L6.238,1a.618.618,0,0,1,.254.036.534.534,0,0,1,.182.218l4.868,16.313a.379.379,0,1,1-.727.218L6.057,1.8,2.5,2.926l.254.836,2.4-.727a.41.41,0,0,1,.291.036.534.534,0,0,1,.182.218l4.432,14.9a.369.369,0,0,1-.254.472H9.69Z",
    transform: "translate(-1.638 -1)",
    fill: "#7d0000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_982",
    "data-name": "Grupo 982",
    transform: "translate(7.038 5.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_980",
    "data-name": "Grupo 980",
    transform: "translate(3.178 0.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1483",
    "data-name": "Caminho 1483",
    d: "M31.045,23.166h-.109a.359.359,0,0,1-.254-.254l-.908-3.052a.41.41,0,0,1,.036-.291.534.534,0,0,1,.218-.182l2.471-.727a.369.369,0,0,1,.472.254l.908,3.052a.447.447,0,0,1-.073.363.329.329,0,0,1-.363.109l-1.272-.254-.872.872a.33.33,0,0,1-.254.109Zm-.436-3.2.618,2.071.545-.545a.366.366,0,0,1,.327-.109l.836.145-.618-2.107Z",
    transform: "translate(-29.759 -18.638)",
    fill: "#7d0000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_981",
    "data-name": "Grupo 981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1484",
    "data-name": "Caminho 1484",
    d: "M25.621,28.741a.4.4,0,0,1-.363-.254.369.369,0,0,1,.254-.472l6.5-1.926a.94.94,0,0,0,.509-.4.748.748,0,0,0,.073-.618l-2.107-7.085a.805.805,0,0,0-1.017-.545L22.387,19.55a.805.805,0,0,0-.545,1.017l2.071,6.976a.379.379,0,1,1-.727.218l-2.107-7.012a1.57,1.57,0,0,1,1.054-1.962l7.085-2.107a1.57,1.57,0,0,1,1.962,1.054l2.107,7.085a1.705,1.705,0,0,1-.109,1.2,1.634,1.634,0,0,1-.945.763l-6.5,1.926c-.036,0-.073.036-.109.036Z",
    transform: "translate(-21.011 -16.611)",
    fill: "#7d0000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_985",
    "data-name": "Grupo 985",
    transform: "translate(5.277 1.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_983",
    "data-name": "Grupo 983",
    transform: "translate(1.888 0.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1485",
    "data-name": "Caminho 1485",
    d: "M22.246,8.6h-.109a.359.359,0,0,1-.254-.254l-.509-1.744a.41.41,0,0,1,.036-.291c0-.109.109-.182.182-.218l1.417-.436a.369.369,0,0,1,.472.254l.509,1.744a.447.447,0,0,1-.073.363.329.329,0,0,1-.363.109L22.9,8.022l-.436.436a.226.226,0,0,1-.218.145Zm-.073-1.889.254.8.145-.145a.366.366,0,0,1,.327-.109l.218.036-.254-.8Z",
    transform: "translate(-21.359 -5.638)",
    fill: "#7d0000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_984",
    "data-name": "Grupo 984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1486",
    "data-name": "Caminho 1486",
    d: "M18.465,11.9a.834.834,0,0,1-.509-.145,1.027,1.027,0,0,1-.509-.654L16.212,6.992a1.065,1.065,0,0,1,.727-1.344l4.105-1.235a1.065,1.065,0,0,1,1.344.727l1.235,4.105a1.065,1.065,0,0,1-.727,1.344l-4.105,1.235a1.061,1.061,0,0,1-.327.073Zm2.87-6.721h-.109L17.157,6.41a.313.313,0,0,0-.218.4l1.235,4.105a.363.363,0,0,0,.145.182.539.539,0,0,0,.254.036L22.679,9.9a.313.313,0,0,0,.218-.4L21.662,5.393a.368.368,0,0,0-.327-.218Z",
    transform: "translate(-16.162 -4.362)",
    fill: "#7d0000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_986",
    "data-name": "Grupo 986",
    transform: "translate(11.19 14.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1487",
    "data-name": "Caminho 1487",
    d: "M33.7,45.69a.4.4,0,0,1-.363-.254.369.369,0,0,1,.254-.472l8.865-2.652-.436-1.417-9.083,2.761a.379.379,0,0,1-.218-.727l9.446-2.87a.284.284,0,0,1,.291.036.534.534,0,0,1,.182.218l.618,2.144a.41.41,0,0,1-.036.291.534.534,0,0,1-.218.182L33.769,45.69c0-.036-.036,0-.073,0Z",
    transform: "translate(-32.438 -40.034)",
    fill: "#7d0000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_987",
    "data-name": "Grupo 987",
    transform: "translate(6.655 16.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1488",
    "data-name": "Caminho 1488",
    d: "M23.024,52.128a2.879,2.879,0,0,1-1.453-.363,3.034,3.034,0,0,1-1.49-1.853,3.1,3.1,0,0,1,2.071-3.851,2.981,2.981,0,0,1,2.362.254A3.034,3.034,0,0,1,26,48.167a2.981,2.981,0,0,1-.254,2.362,3.034,3.034,0,0,1-1.853,1.49A3.373,3.373,0,0,1,23.024,52.128Zm0-5.45a2.469,2.469,0,0,0-.69.109,2.333,2.333,0,0,0,1.344,4.469,2.259,2.259,0,0,0,1.381-1.126,2.343,2.343,0,0,0,.182-1.78,2.259,2.259,0,0,0-1.126-1.381A2.22,2.22,0,0,0,23.024,46.678Z",
    transform: "translate(-19.957 -45.923)",
    fill: "#7d0000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_988",
    "data-name": "Grupo 988",
    transform: "translate(8.128 17.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1489",
    "data-name": "Caminho 1489",
    d: "M25.605,53.281a1.953,1.953,0,0,1-.763-.182,1.634,1.634,0,0,1-.763-.945,1.57,1.57,0,0,1,1.054-1.962,1.705,1.705,0,0,1,1.2.109,1.634,1.634,0,0,1,.763.945,1.705,1.705,0,0,1-.109,1.2,1.634,1.634,0,0,1-.945.763.852.852,0,0,1-.436.073Zm0-2.4a.709.709,0,0,0-.254.036.829.829,0,0,0-.545,1.054.94.94,0,0,0,.4.509.816.816,0,0,0,.654.073.94.94,0,0,0,.509-.4.748.748,0,0,0,.073-.618.94.94,0,0,0-.4-.509.7.7,0,0,0-.436-.145Z",
    transform: "translate(-24.011 -50.131)",
    fill: "#7d0000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFornecedores);
export default __webpack_public_path__ + "static/media/fornecedores.60b8780ede875fe6076d6903cc86d399.svg";
export { ForwardRef as ReactComponent };